import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const InteractionAlert = ({ interactions, onViewDetails, onDismiss }) => {
  const getSeverityConfig = (severity) => {
    switch (severity) {
      case 'critical':
        return {
          bgColor: 'bg-destructive/10',
          borderColor: 'border-destructive/20',
          textColor: 'text-destructive',
          icon: 'AlertCircle',
          iconColor: 'var(--color-destructive)'
        };
      case 'major':
        return {
          bgColor: 'bg-warning/10',
          borderColor: 'border-warning/20',
          textColor: 'text-warning',
          icon: 'AlertTriangle',
          iconColor: 'var(--color-warning)'
        };
      case 'moderate':
        return {
          bgColor: 'bg-primary/10',
          borderColor: 'border-primary/20',
          textColor: 'text-primary',
          icon: 'Info',
          iconColor: 'var(--color-primary)'
        };
      default:
        return {
          bgColor: 'bg-muted',
          borderColor: 'border-border',
          textColor: 'text-foreground',
          icon: 'Info',
          iconColor: 'var(--color-muted-foreground)'
        };
    }
  };

  if (!interactions || interactions?.length === 0) {
    return null;
  }

  return (
    <div className="space-y-3">
      {interactions?.map((interaction, index) => {
        const config = getSeverityConfig(interaction?.severity);
        
        return (
          <div
            key={index}
            className={`${config?.bgColor} border ${config?.borderColor} rounded-lg p-4 transition-smooth`}
          >
            <div className="flex items-start gap-3">
              <Icon 
                name={config?.icon} 
                size={20} 
                color={config?.iconColor}
                className="flex-shrink-0 mt-0.5"
              />
              
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2 mb-2">
                  <h4 className={`text-sm md:text-base font-semibold ${config?.textColor}`}>
                    {interaction?.title}
                  </h4>
                  <span className={`px-2 py-1 rounded text-xs font-medium ${config?.textColor} ${config?.bgColor} border ${config?.borderColor}`}>
                    {interaction?.severity?.charAt(0)?.toUpperCase() + interaction?.severity?.slice(1)}
                  </span>
                </div>

                <p className={`text-xs md:text-sm ${config?.textColor} mb-3`}>
                  {interaction?.description}
                </p>

                <div className="bg-card/50 rounded-lg p-3 mb-3">
                  <p className="text-xs font-medium text-foreground mb-1">Interacting Medications:</p>
                  <div className="flex flex-wrap gap-2">
                    {interaction?.medications?.map((med, idx) => (
                      <span
                        key={idx}
                        className="px-2 py-1 bg-muted rounded text-xs font-medium text-foreground"
                      >
                        {med}
                      </span>
                    ))}
                  </div>
                </div>

                {interaction?.recommendation && (
                  <div className="bg-card/50 rounded-lg p-3 mb-3">
                    <p className="text-xs font-medium text-foreground mb-1">Clinical Recommendation:</p>
                    <p className="text-xs text-muted-foreground">{interaction?.recommendation}</p>
                  </div>
                )}

                <div className="flex flex-wrap gap-2">
                  <Button
                    variant="outline"
                    size="sm"
                    iconName="FileText"
                    iconPosition="left"
                    onClick={() => onViewDetails(interaction)}
                  >
                    View Details
                  </Button>
                  {onDismiss && (
                    <Button
                      variant="ghost"
                      size="sm"
                      iconName="X"
                      iconPosition="left"
                      onClick={() => onDismiss(interaction?.id)}
                    >
                      Dismiss
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default InteractionAlert;